import axios from "axios";
import { BASE_API_URL } from "../api";
import {
  ColorAbsent,
  ColorCompleted,
  ColorPallet,
  ColorProgress,
  ColorOpen,
} from "../utils/colorPallet";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
export const SelectMenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    },
  },
};
// export const getClinicImage = (id: string) => {
//   return `${BASE_API_URL}/api/clinic/image?id=${id}`;
// };

export const tConvert = (time: any) => {
  // Check correct time format and split into components
  time = time?.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [
    time,
  ];

  if (time.length > 1) {
    // If time format correct
    time = time.slice(1); // Remove full string match value
    time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
    time[0] = +time[0] % 12 || 12; // Adjust hours
  }
  return time.join(""); // return adjusted time or original string
};
export const IsComponentPermission = (
  url: string,
  permission: string,
  componentsPermissions: any
) => {
  const isFound = componentsPermissions?.find(
    (item: any) => item.path_name === url
  );
  const res = isFound?.permissions?.some(
    (per: any) =>
      per.submodule?.toLocaleLowerCase() === permission?.toLocaleLowerCase()
  );
  return res;
};
export const getInitials = (name = "") =>
  name
    .replace(/\s+/, " ")
    .split(" ")
    .slice(0, 2)
    .map((v) => v && v[0].toUpperCase())
    .join("");

export const getStaffImage = (
  staffId: string,
  clinicId: string,
  file_name: string = "pic.jpg"
) => {
  return `${BASE_API_URL}/api/staff/image?staff_id=${staffId}&clinic_id=${clinicId}&filename=${file_name}`;
};
export const scrollIntoView = (ref: any) => {
  const element = document.getElementById(ref);
  if (element) {
    element.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
  }
};
export const openInNewTab = (url: string): void => {
  const newWindow = window.open(url, "_blank", "noopener,noreferrer");
  if (newWindow) newWindow.opener = null;
};
export const getPharmacyImage = (id: any) => {
  return `${BASE_API_URL}/api/pharmacy/pharmacyProfile/image?pharmacy_id=${id}`;
};


export async function getFileFromUrl(
  url: string,
  name: string,
  defaultType = "image/jpeg"
) {
  const file = await loadFile(url, name, defaultType);
  return file;
}

export async function loadFile(
  url: string,
  name: string,
  defaultType = "image/jpeg"
) {
  const response = await axios({
    url: url,
    method: "GET",
    responseType: "blob", // important
  });
  const data = new Blob([response.data]);
  const file = await new File([data], name, {
    type: defaultType,
  });
  return file;
}

export const formatTo12HourTime = (timeString: string): string => {
  // Check if the input is in 12-hour format (with AM/PM)
  const is12HourFormat = /[APap][Mm]/.test(timeString);

  let hours: number;
  let minutes: number;
  let seconds: number = 0; // Default to 0 seconds if not provided
  
  // Parse the time string (assuming 'HH:mm' format if no AM/PM is provided)
  if (is12HourFormat) {
    // If time is in 12-hour format, we will need to convert it
    const [timePart, period] = timeString.split(" ");
    const [hour, minute] = timePart.split(":").map((num) => parseInt(num, 10));
    
    hours = hour;
    minutes = minute;

    // If it's PM, add 12 hours except for 12 PM which is unchanged
    if (period.toUpperCase() === "PM" && hours !== 12) {
      hours += 12;
    } else if (period.toUpperCase() === "AM" && hours === 12) {
      hours = 0; // 12 AM is 00:00 in 24-hour format
    }
  } else {
    // If no AM/PM is provided, assume 24-hour format (e.g., "15:30")
    const [hour, minute] = timeString.split(":").map((num) => parseInt(num, 10));
    hours = hour;
    minutes = minute;
  }

  // Convert 24-hour time to 12-hour format
  const ampm = hours >= 12 ? "PM" : "AM";
  const formattedHours = hours % 12 || 12; // Convert '0' hours to '12'
  const formattedMinutes = String(minutes).padStart(2, "0"); // Pad minutes to 2 digits
  const formattedSeconds = String(seconds).padStart(2, "0"); // Pad seconds to 2 digits

  // Return formatted time with AM/PM
  return `${formattedHours}:${formattedMinutes}:${formattedSeconds} ${ampm}`;
};

export const invertTo24HourTime = (time12hr: string) => {
  const [time, period] = time12hr.split(" "); // Split time and AM/PM
  const [hours, minutes] = time.split(":").map(Number); // Extract hours and minutes
  
  let hours24 = hours;
  
  // If AM and hours are 12, convert it to 0 for midnight
  if (period === "AM" && hours === 12) {
    hours24 = 0;
  }
  
  // If PM and hours are not 12, add 12 for afternoon/evening hours
  if (period === "PM" && hours !== 12) {
    hours24 = hours + 12;
  }
  
  // Format the result into 24-hour format "HH:mm"
  const formattedTime = `${String(hours24).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
  return formattedTime;
};


export const getStatusStyle = (status: string) => {
  switch (status) {
      case "Completed":
          return {
              backgroundColor: ColorCompleted.bgColor,
              color: ColorCompleted.textColor,
          };
      case "Absent":
          return {
              backgroundColor: ColorAbsent.bgColor,
              color: ColorAbsent.textColor,
          };
      case "In Progress":
          return {
              backgroundColor: ColorProgress.bgColor,
              color: ColorProgress.textColor,
          };
          case "In Progress - Late":
            return {
                backgroundColor: ColorProgress.bgColor,
                color: ColorProgress.textColor,
            };
      case "Upcoming":
          return {
              backgroundColor: ColorOpen.bgColor,
              color: ColorOpen.textColor,
          };
      default:
          return {
              
              color: "grey",
          };
  }
};

export const extractDate = (checkIn: string): string => {
  if (checkIn === "") return "";
  const dateObj = new Date(checkIn);
  return dateObj?.toISOString()?.split('T')?.[0];
};

export const computeShiftStatus = (
  startTime: string,
  endTime: string,
  checkIn: string,
  checkOut: string
): string => {
  const now = new Date();

  // Convert startTime and endTime to Date objects
  const checkInDate = checkIn?.split('T')?.[0]
  if (startTime && endTime)
    {
  const startTimeObj = new Date(`${checkInDate}T${convertTo24Hour(startTime)}`);
  
  let endTimeObj = new Date(`${checkInDate}T${convertTo24Hour(endTime)}`);

  // Adjust endTime if it crosses midnight
  if (endTimeObj < startTimeObj) {
    endTimeObj.setDate(endTimeObj.getDate() + 1);
  }
  const checkInObj = new Date(checkIn);
  const checkOutObj = new Date(checkOut);
  // Determine the shift status
  if (now < startTimeObj  ) {
    return "Upcoming";
  } else if (checkInObj <= startTimeObj && now < endTimeObj) {
    return "In Progress";
  } else if (checkInObj > startTimeObj && now < endTimeObj) {
    return "In Progress - Late";
  } else if (checkInObj <= startTimeObj && checkOutObj >= endTimeObj) {
    return "Completed";
  } else if (checkInObj > startTimeObj || checkOutObj < endTimeObj) {
    return "Absent";
  } else {
    return "";
  }
}
else{
  return "";
}
};
export function getTimeFromISOString(dateString: string): string {
  const date = new Date(dateString);
  const time = date.toLocaleTimeString('en-GB', { hour12: true });
  return time;
}

export const formatExpDate = (dateStr: string): string => {
  const date = new Date(dateStr);
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0"); 
  const dd = String(date.getDate()).padStart(2, "0");

  return `${dd}/${mm}/${yyyy}`;
};


// Helper function to convert 12-hour time to 24-hour time
const convertTo24Hour = (time: string): string => {
  const [timePart, meridian] = time?.split(" ");
  const [hours, minutes] = timePart?.split(":")?.map(Number);
  const convertedHours =
    meridian === "PM" && hours !== 12 ? hours + 12 : meridian === "AM" && hours === 12 ? 0 : hours;
  return `${convertedHours?.toString()?.padStart(2, "0")}:${minutes?.toString()?.padStart(2, "0")}`;
};



export function getLatestCheckInCheckout(staffId: number, records: any[]): any | { message: string } {
  const staffRecords = records?.filter(record => record?.pharmacyStaff?.id === String(staffId));
  if (staffRecords?.length === 0) {
    return { message: 'No records found for this staff ID.' };
  }
  const latestRecord = staffRecords?.reverse()?.[0];
  return {
    staffId,
    latestCheckIn: latestRecord?.check_in,
    latestCheckOut: latestRecord?.check_out ?? ' ',
  };
}



export function calculateHoursDifference(startDate: string, endDate: string): number {
  const start = new Date(startDate);
  const end = new Date(endDate);
  if (isNaN(start.getTime()) || isNaN(end.getTime())) {
    throw new Error('Invalid date string(s)');
  }
  const differenceInMillis = end.getTime() - start.getTime();
  const differenceInHours = differenceInMillis / (1000 * 60 * 60);
  const roundedDifferenceInHours = parseFloat(differenceInHours.toFixed(1));
  return roundedDifferenceInHours;
}

export function filterCheckInsByWeek(records: any) {
  const currentDate = new Date();
  const oneWeekAgo = new Date();
  oneWeekAgo.setDate(currentDate.getDate() - 7);
  const filteredRecords = records?.filter((record: any) => {
    const checkInDate = new Date(record?.check_in);
    return checkInDate >= oneWeekAgo;
  });
  return filteredRecords;
}

export function getCurrentDateFormatted(): string {
  const date = new Date();
  const options: Intl.DateTimeFormatOptions = {
      month: 'long',
      day: 'numeric',
      year: 'numeric'
  };

  const formattedDate = date.toLocaleDateString('en-US', options);

  // Adding the ordinal suffix
  const day = date.getDate();
  let suffix = "th";
  if (day % 10 === 1 && day !== 11) suffix = "st";
  else if (day % 10 === 2 && day !== 12) suffix = "nd";
  else if (day % 10 === 3 && day !== 13) suffix = "rd";

  return formattedDate.replace(/\d+/, `${day}${suffix}`);
}

export function convertTo24HourFormat(time: string) {
  return time.replace(
    /(\d+):(\d+) (AM|PM)/,
    (match, hour, minute, period) => {
      let hour24 = parseInt(hour);

      // Check for valid hour range (1-12) and prevent negative hours
      if (hour24 < 1 || hour24 > 12) {
        throw new Error("Invalid hour in time format");
      }

      if (period === "PM" && hour24 !== 12) hour24 += 12;
      if (period === "AM" && hour24 === 12) hour24 = 0;

      // Ensure hour is between 0 and 23 after conversion
      if (hour24 < 0) hour24 = 0;
      if (hour24 > 23) hour24 = 23;

      return `${hour24.toString().padStart(2, "0")}:${minute}`;
    }
  );
}






